const pad = (num: number) => String(num).padStart(2, "0")

const DEFAULT_FALLBACK = "00:00"

export function formatAudioTime(
  secondsInput?: number,
  fallback = DEFAULT_FALLBACK
): string {
  if (secondsInput === undefined || isNaN(secondsInput)) return fallback
  const totalSeconds = Math.round(secondsInput) // round like 40.56 => 41
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  if (hours > 0) {
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
  } else {
    return `${pad(minutes)}:${pad(seconds)}`
  }
}
